import type { Page, RestReadContext } from '@rammetec/data-access'
import {
  invoiceItemRestScriptGetAll,
  invoiceRestScriptGetAll,
} from './restScriptInvoiceHandler'
import { partyRestScriptGetAll } from './restScriptPartyHandler'
import { productRestScriptGetAll } from './restScriptProductHandler'

/**
 * RestScript `getAll` entry point — dispatches by entity table name to the
 * VectorHub-backed legacy read handlers registered for this org.
 */
export async function restScriptGetAll(
  ctx: RestReadContext,
): Promise<unknown[] | Page<unknown>> {
  switch (ctx.tableName) {
    case 'Product':
      return productRestScriptGetAll(ctx)
    case 'Party':
      return partyRestScriptGetAll(ctx)
    case 'Invoice':
      return invoiceRestScriptGetAll(ctx)
    case 'InvoiceItem':
      return invoiceItemRestScriptGetAll(ctx)
    default:
      return []
  }
}
